import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPartRepairSites, getRepairsbySitePart, saveSiteRepairTypes } from "../../../../modules/ConfigurationModule/services/SupplyChainService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";

export const internalRepairSlice = createSlice({
    name: "internalRepair",
    initialState: {
        sites: [],
        idxSites: {},
        repairs: {},
        idxRepairs: {}
    },
    reducers:{
        addSite: (state, action)=>{
            let newSite = {tempId: crypto.randomUUID(), id: null, locationName: null, siteName: null, siteType: null, repairTypes: 0, locationId: null, siteId: null};
            return {...state, sites: [newSite.tempId, ...(state.sites ?? [])], idxSites: {...state.idxSites, [newSite.tempId]:newSite}}
        },
        addRepair: (state, action)=>{
            let {siteTempId, partId} = action.payload;
            let newRepair = {tempId: crypto.randomUUID(), id: null, partId, quantity:null, siteId: state.idxSites[siteTempId].id, repairTypeId: null, tatAverage:null, tatEstimated: null};
            return {...state, repairs: {...state.repairs, [siteTempId]: [newRepair.tempId, ...(state.repairs[siteTempId] ?? [])]}, idxRepairs: {...state.idxRepairs, [newRepair.tempId]: newRepair}}
        },
        updateRepair: (state, action)=>{
            let {repairTempId, e} = action.payload;
            let {name, value} = e;
            return {...state, idxRepairs:{...state.idxRepairs, [repairTempId]:{...state.idxRepairs[repairTempId], [name]: value}}}
        },
        updateSite: (state, action) => {
            let {siteTempId, partialSite} = action.payload;
            if (siteId in partialSite) {
                let updatedRepairs = [...state.repairs[siteTempId]].map(repairTempId => ({...state.idxRepairs[repairTempId], siteId: siteId}))
                return {...state, idxSites:{...state.idxSites, [siteTempId]:{...state.idxSites[siteTempId], ...partialSite}}}
            }
            return {...state, idxSites:{...state.idxSites, [siteTempId]:{...state.idxSites[siteTempId], ...partialSite}}}
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRepairSites.fulfilled, (state, action) => {
            let sites = action.payload.load?.map(s => ({...s, tempId:crypto.randomUUID()}));
            return({...state, sites: sites.map(s => s.tempId), idxSites: Object.fromEntries(sites.map(s => [s.tempId, s]))})
        });
        builder.addCase(fetchSiteRepairs.fulfilled, (state, action) => {
            let repairs = action.payload.load?.map(s => ({...s, tempId:crypto.randomUUID()}));
            let siteTempId = action.payload.siteTempId;
            return({...state, repairs:{...state.repairs, [siteTempId]:repairs.map(r => r.tempId)} ,idxRepairs: {...state.idxRepairs, ...Object.fromEntries(repairs.map(s => [s.tempId, s]))}})
        });
        builder.addCase(saveSiteRepairs.fulfilled, (state, action) => {
            let repairs = action.payload.load?.map(s => ({...s, tempId:crypto.randomUUID()}));
            let siteTempId = action.payload.siteTempId;
            return({...state, repairs:{...state.repairs, [siteTempId]:repairs.map(r => r.tempId)} ,idxRepairs: {...state.idxRepairs, ...Object.fromEntries(repairs.map(s => [s.tempId, s]))}})
        });
    }
});

export const fetchRepairSites = createAsyncThunk("internalRepair/fetchRepairSites", 
    async ({partId}, {rejectWithValue, getState}) => {
        try {
            let response = await getPartRepairSites(partId);
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch {
            return rejectWithValue(null);
        }
    }
)

export const fetchSiteRepairs = createAsyncThunk("internalRepair/fetchSiteRepairs", 
    async ({partId, siteId, siteTempId}, {rejectWithValue, getState}) => {
        try {
            let response = await getRepairsbySitePart(partId, siteId);
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                return {...response.data, siteTempId};
            } else {
                return rejectWithValue(response.data);
            }
        } catch {
            return rejectWithValue(null);
        }
    }
)

export const saveSiteRepairs = createAsyncThunk("internalRepair/saveSiteRepairs", 
    async({siteTempId}, {rejectWithValue, getState}) => {
        let {repairs, idxRepairs} = getState();
        let array = repairs[siteTempId].map(rId => idxRepairs[rId]);
        try {
            let response = await saveSiteRepairTypes(array);
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS){
                return({...response.data, siteTempId});
            }
            else {
                return rejectWithValue(response.data);
            }
        } catch {
            return rejectWithValue(null);

        }
    }
)

export const {addSite, addRepair, updateSite, updateRepair} = internalRepairSlice.actions;
export default internalRepairSlice.reducer;

